// extracted by mini-css-extract-plugin
export default {"tooltip":"MenuButton_tooltip__FEfqy"};